import { money } from "@/lib/money";

export default function PlanBreakdown({ plans }) {
  return (
    <section className="brutal-border p-4 sm:p-5 min-w-0" data-testid="revenue-plans">
      <div className="font-mono-label text-[10px] text-muted-foreground mb-3">CLIENTS BY PLAN</div>
      <div className="divide-y divide-[#262626]">
        {plans.map((p) => (
          <div key={p.plan} className="py-2.5 flex items-center justify-between gap-3" data-testid={`revenue-plan-${p.plan.replace(/\W+/g, "-").toLowerCase()}`}>
            <div className="min-w-0">
              <div className="text-sm font-semibold truncate">{p.plan}</div>
              <div className="text-xs text-muted-foreground">{p.clients} client{p.clients === 1 ? "" : "s"}</div>
            </div>
            <div className="text-right text-sm shrink-0">
              <div>{money(p.mrr_cents)}<span className="text-muted-foreground text-xs"> /mo</span></div>
              <div className="text-xs text-muted-foreground">{money(p.net_cents)} net lifetime</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
